function o(n) {
  return window.TouchEvent && n instanceof window.TouchEvent;
}
export {
  o as isTouchEvent
};
